<template>
  <div id="error">
    <h1 class="head">The site cannot be built correctly.</h1>
    <h2 class="reason">reason: {{ reason }}</h2>
    <h3 class="message" v-html="message"></h3>
    
  </div>
</template>

<script>
export default {
  name: 'Error',
  computed: {
    reason () {
      return this.$route.params.reason
    },
    message () {
      const reason = this.reason
      let message = ''
      switch (reason) {
        case 'site':
          message = 'The site ID is missing in the parameter.<div class="trans">파라미터에 사이트ID가 누락되었습니다.</div>'
          break
        case 'setting':
          message = 'There is no configuration file.<div class="trans">설정파일이 없습니다.</div>The configuration file might be missing in the editor, or the site ID might be incorrect.<div class="trans">에디터에서 저장된 설정파일이 없거나 잘못된 사이트ID일 수 있습니다.</div>'
          break
      }
      return message
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
#error {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  padding-top: 30px;
  padding-bottom: 20%;
  background-color: $bg-default;
  .head {
    font-size: 1.4vw;
  }
  .reason {
    text-transform: uppercase;
    margin-bottom: 0.3em;
    font-size: 2vw;
    font-weight: 900;
    color: $color-red;
  }
  .message {
    div {
      display: none;
    }
    &::v-deep .trans {
      margin-bottom: 0.5em;
      color: $color-blue;
    }
  }
}
</style>
